import { useAppSelector } from "..";

export function useDocumentTypes() {
  return useAppSelector(({ documents }) => documents.documentTypes);
}
